import { useRef } from "react";
import { IExtendedSearchData } from "src/api/server/extended-search.types";

export const useIsNewSearchPageVisit = (data: IExtendedSearchData): boolean => {
    const lastVisitDataRef = useRef<IExtendedSearchData | null>(null);
    const isNewVisit = lastVisitDataRef.current !== data;
    lastVisitDataRef.current = data;

    return isNewVisit;
};
